export const devConfig = {
  ManagerServer: {
    rest: {
      port: 8093,
      hostname: "37.187.19.119",
      url: "https://wyniki-online.pl:8093",
    },
  },
}
